import type { HistoricalQueryOptions, RequestOptions } from '../types/client.js';

export function getRetryDelay(attempt: number): number {
  const baseDelay = 200 * Math.pow(2, attempt);
  const jitter = baseDelay * 0.25 * (Math.random() * 2 - 1);
  return Math.round(baseDelay + jitter);
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function isRequestOptions(
  value: HistoricalQueryOptions | RequestOptions | undefined,
): value is RequestOptions {
  return Boolean(
    value &&
    typeof value === 'object' &&
    ('cacheTtl' in value || 'noRetry' in value || 'signal' in value),
  );
}

export function splitHistoricalArgs<T extends HistoricalQueryOptions>(
  paramsOrOptions?: T | RequestOptions,
  options?: RequestOptions,
): { params: T | undefined; options: RequestOptions | undefined } {
  if (options) {
    return {
      params: paramsOrOptions as T | undefined,
      options,
    };
  }

  if (!paramsOrOptions) {
    return { params: undefined, options: undefined };
  }

  if (isRequestOptions(paramsOrOptions)) {
    return { params: undefined, options: paramsOrOptions };
  }

  return {
    params: paramsOrOptions,
    options: undefined,
  };
}
